import React from "react";
import parse from "html-react-parser";
import { Box, styled } from "@mui/material";
import { fromPublic, replaceGlobalConfigVars } from "../../utils";

type DropdownContentProps = {
  content: string;
  iconUrl?: string;
};

const StyledBox = styled(Box)<{ iconUrl: string }>`
  text-align: left;
  && p {
    color: #2F383C;
    font-size: 0.875rem !important; /* Use relative units */
    font-style: normal;
    font-weight: 400 !important;
    line-height: 1.5 !important; /* Use relative line height */
    letter-spacing: -0.02em;
  }
  && li {
    color: #2F383C;
    font-size: 0.875rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    letter-spacing: -0.02em;
  }
  ul {
    padding-left: 1.5em;
    list-style-type: disc;
    li {
      margin-bottom: 0.5em;
    }
  }
  ol {
    padding-left: 1.5em;
    list-style-type: decimal;
    li {
      margin-bottom: 0.5em;
    }
  }
  .icon-list {
    list-style-type: none;
    padding-left: 0;
  }
  .icon-list li {
    position: relative;
    padding-left: 1.5em;
    background: url("${(props) => props.iconUrl}") no-repeat left 0.2em;
    background-size: 1em; /* Scale with font size */
    min-height: 1em;
    margin-bottom: 0.5em;
  }
`;

const DropdownContent: React.FC<DropdownContentProps> = ({ content, iconUrl }) => {
   const processedContent = replaceGlobalConfigVars(content);
   return <StyledBox iconUrl={fromPublic(iconUrl)}>{parse(processedContent)}</StyledBox>;
 };
 
  export default DropdownContent;